// src/components/music/AUDTipModal.js

import React from 'react';

// Dynamic style function mapper accepting explicit theme parameters
const getStyles = (isDarkMode) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0.85)' : 'rgba(0, 0, 0, 0.65)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    pointerEvents: 'auto',
    backdropFilter: 'blur(6px)', // Enhanced frosted glass depth
  },
  modal: {
    backgroundColor: isDarkMode ? '#18181b' : '#FFFFFF', 
    color: isDarkMode ? '#f4f4f5' : '#18181b',          
    padding: '35px 30px', // Extra breathing room for the longer title
    borderRadius: '24px', // Softer, premium curves
    textAlign: 'center',
    width: '90%',
    maxWidth: '360px',
    border: isDarkMode ? '1px solid #27272a' : '1px solid #f4f4f5', 
    boxShadow: isDarkMode 
      ? '0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 40px rgba(255, 0, 204, 0.15)' // Added signature brand glow in dark mode
      : '0 25px 50px -12px rgba(15, 23, 42, 0.15), 0 10px 20px -5px rgba(15, 23, 42, 0.05)',
    transition: 'background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease',
  },
  title: {
    margin: 0,
    marginBottom: '16px',
    fontSize: '20px', // Adjusted size to balance out the longer text block
    fontWeight: '900', 
    textTransform: 'uppercase',
    letterSpacing: '-0.03em',
    fontStyle: 'italic',
    lineHeight: '1.25',
  },
  text: {
    margin: 0,
    marginBottom: '28px',
    fontSize: '13px',
    lineHeight: '1.6',
    fontWeight: '500',
    color: isDarkMode ? '#a1a1aa' : '#52525b', 
  },
  closeButton: {
    backgroundColor: '#ff00cc', 
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '12px',
    padding: '14px 25px',
    fontSize: '11px',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '0.08em', // Increased tracking for a cleaner lockup
    cursor: 'pointer',
    width: '100%',
    boxShadow: '0 4px 20px rgba(255, 0, 204, 0.4)', // Slightly punchier shadow
    transition: 'transform 0.1s ease, filter 0.2s ease, box-shadow 0.2s ease',
  }
});

const AUDTippingModal = ({ isOpen, onClose, isDarkMode }) => {
  if (!isOpen) {
    return null;
  }

  const styles = getStyles(isDarkMode);

  const handleOverlayClick = (e) => {
    if (e.target.id === 'tipping-modal-overlay') {
      onClose();
    }
  };

  return (
    <div 
      id="tipping-modal-overlay" 
      style={styles.overlay} 
      onClick={handleOverlayClick}
    >
      <div style={styles.modal}>
        <h2 style={styles.title}>
          A Brand New Tipping Experience is Coming Soon
        </h2>
        <p style={styles.text}>
          We're redesigning how you support your favorite artists. Get ready for a faster, more rewarding way to show your appreciation!
        </p>
        <button 
          style={styles.closeButton} 
          onClick={onClose}
          onMouseEnter={(e) => { 
            e.currentTarget.style.filter = 'brightness(1.1)'; 
            e.currentTarget.style.boxShadow = '0 6px 24px rgba(255, 0, 204, 0.5)';
          }}
          onMouseLeave={(e) => { 
            e.currentTarget.style.filter = 'none'; 
            e.currentTarget.style.boxShadow = styles.closeButton.boxShadow;
          }}
          onMouseDown={(e) => { e.currentTarget.style.transform = 'scale(0.97)'; }}
          onMouseUp={(e) => { e.currentTarget.style.transform = 'none'; }}
        >
          Awesome, Can't Wait!
        </button>
      </div>
    </div>
  );
};

export default AUDTippingModal;